import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
// import { IndicatorsComponent } from './indicators/indicators.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RelatoriosRoutingModule {}
